import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'
import _ from 'lodash'

import Select from 'components/Select'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function FilterRiskOwnerSelect({
  disabled = false,
  value = null,
  onChange = () => null,
}) {
  const { t } = useTranslate()

  const filterRiskOwners = useStoreState((state) => state.filter.riskOwners)

  const getRiskOwners = useStoreActions((actions) => actions.filter.getRiskOwners)

  const options = _.map(filterRiskOwners, (filterRiskOwner) => {
    return {
      label: filterRiskOwner?.name,
      value: filterRiskOwner?.id,
    }
  })

  useAsync(async () => {
    getRiskOwners()
  }, [])

  const selectProps = {
    defaultValue: value,
    disabled,
    options,
    placeholder: t('Please select risk owner'),
    onChange,
  }

  return (
    <Styled className="filter-risk-owner-select-component">
      <Select {...selectProps} />
    </Styled>
  )
}
